
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.073 4.91C21.024 6.852 22 9.19 22 11.93c0 2.738-.976 5.078-2.927 7.018-1.952 1.94-4.302 2.911-7.05 2.911a9.6 9.6 0 01-4.73-1.22L2 22l1.405-5.117a9.88 9.88 0 01-1.311-4.977c0-2.723.968-5.055 2.904-6.995C6.934 2.97 9.276 2 12.023 2c2.748 0 5.098.97 7.05 2.91zm-7.05 15.259c2.28 0 4.232-.806 5.855-2.418 1.624-1.612 2.436-3.56 2.436-5.845 0-2.285-.812-4.233-2.436-5.845-1.623-1.612-3.575-2.418-5.855-2.418-2.279 0-4.223.806-5.831 2.418-1.608 1.612-2.412 3.56-2.412 5.845 0 1.596.421 3.067 1.265 4.413l.187.282-.843 3.052 3.138-.798.281.14a8.088 8.088 0 004.215 1.174zm4.544-6.197c.28.156.437.266.468.329.125.187.078.579-.14 1.173-.094.25-.328.493-.703.728-.375.235-.703.383-.984.446a4.168 4.168 0 01-1.545-.094c-.531-.188-1-.36-1.405-.516-.25-.126-.492-.259-.726-.4-.235-.14-.461-.281-.68-.422a6.13 6.13 0 01-.608-.446 16.541 16.541 0 01-.54-.47 7.305 7.305 0 01-.49-.493c-.157-.172-.29-.32-.399-.446a8.922 8.922 0 01-.328-.399l-.257-.328a2.136 2.136 0 01-.164-.235l-.07-.117c-.688-.908-1.031-1.769-1.031-2.582 0-.752.297-1.44.89-2.066.187-.22.406-.329.656-.329.187 0 .343.016.468.047.25 0 .437.141.562.423.062.094.156.297.281.61l.328.822.14.399c.094.156.11.297.047.422-.093.22-.171.36-.234.423l-.14.14-.141.165-.094.117c-.187.188-.234.36-.14.517a7.122 7.122 0 001.405 1.737c.406.344 1.077.75 2.014 1.22.219.094.39.079.515-.046.375-.47.64-.799.796-.986.125-.188.313-.235.563-.141.187.094.749.36 1.686.798z","fill":"#1FB767"}})])
          )
        }
      }
    